// extracted by mini-css-extract-plugin
export default {"view":"styles-module__[local]___YFMMr","backLink":"styles-module__[local]___MBoRd","title":"styles-module__[local]___ZZzAE"};